import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CreateEvent.css'; // Assuming you will add some styles in this CSS file

const CreateEvent = () => {
  const [eventData, setEventData] = useState({
    title: '',
    description: '',
    date: '',
    startTime: '',
    endTime: '',
    location: '',
    clientEmail: '', // Added client email here
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setEventData({
      ...eventData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      
      // First, create the event
      const response = await fetch('${process.env.REACT_APP_API_URL}/api/events/new', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          title: eventData.title,
          description: eventData.description,
          date: eventData.date,
          startTime: eventData.startTime,
          endTime: eventData.endTime,
          location: eventData.location,
        }),
      });

      if (response.ok) {
        console.log('Event created successfully');

        // Now send the event invite to the client
        const inviteResponse = await fetch('${process.env.REACT_APP_API_URL}/api/events/send-invite', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            email: eventData.clientEmail, // Use the client's email
            eventDetails: {
              title: eventData.title,
              description: eventData.description,
              startTime: eventData.startTime,
              endTime: eventData.endTime,
              location: eventData.location,
            },
          }),
        });

        if (inviteResponse.ok) {
          console.log('Event invite sent successfully');
        } else {
          console.error('Failed to send event invite');
        }

        navigate('/calendar'); // Redirect to calendar after creation
      } else {
        console.error('Failed to create event');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="create-event-container">
      <h1>Create New Event</h1>
      <form onSubmit={handleSubmit} className="create-event-form">
        <div className="form-group">
          <label htmlFor="title">Event Title</label>
          <input
            type="text"
            id="title"
            name="title"
            value={eventData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={eventData.description}
            onChange={handleChange}
            rows="4"
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="date">Event Date</label>
          <input
            type="date"
            id="date"
            name="date"
            value={eventData.date}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="startTime">Start Time</label>
          <input
            type="time"
            id="startTime"
            name="startTime"
            value={eventData.startTime}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="endTime">End Time</label>
          <input
            type="time"
            id="endTime"
            name="endTime"
            value={eventData.endTime}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="location">Location</label>
          <input
            type="text"
            id="location"
            name="location"
            value={eventData.location}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="clientEmail">Client Email</label>
          <input
            type="email"
            id="clientEmail"
            name="clientEmail"
            value={eventData.clientEmail} // Bind the client email to state
            onChange={handleChange}
            placeholder="Client's email address"
            required
          />
        </div>

        <button type="submit" className="create-event-btn">Create Event</button>
      </form>
    </div>
  );
};

export default CreateEvent;
